import { isToolCompleteCommand, PromptResponse, ResponseCommand } from './ai-prompt.types';
import { CanvasCommand } from './canvas-command.types';
import { extractCommandsFromToolResult } from './tool-result-parser';

const CANVAS_COMMAND_TYPES: ReadonlySet<string> = new Set(['canvas_status', 'canvas_close', 'canvas_update']);

export function isCanvasCommand(command: ResponseCommand): command is CanvasCommand {
    return !!command && CANVAS_COMMAND_TYPES.has(command.type);
}

/**
 * Collects a poll response's canvas commands: the top-level ones, then those inside each `tool_complete` result,
 * which seemore wraps as `{type: 'text', text: '…'}`.
 */
export function collectCanvasCommands(response: PromptResponse): CanvasCommand[] {
    const topLevel = response.commands.filter(isCanvasCommand);
    const nested = response.commands
        .filter(isToolCompleteCommand)
        .flatMap((command) => extractCommandsFromToolResult(command.tool_result) ?? []);

    return [...topLevel, ...nested.filter(isCanvasCommand)];
}
